import React from "react";
import { useDrop } from "react-dnd";
import { ColumnType, Task } from "../../types/types";
import Column from "../Column/Column";
import DraggableCard from "../DraggableCard/DraggableCard";

interface DroppableColumnProps {
  title: string;
  tasks: Task[];
  count: number;
  color: string;
  column: ColumnType;
  onDrop: (taskId: number, newColumn: ColumnType) => void;
  onCardClick?: (task: Task) => void;
}

const DroppableColumn: React.FC<DroppableColumnProps> = ({
  title,
  tasks,
  count,
  color,
  column,
  onDrop,
  onCardClick,
}) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "CARD",
    drop: () => {
      return { column };
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div
      ref={drop}
      className={`min-h-[200px] ${isOver && canDrop ? "drop-target" : ""}`}
    >
      <Column title={title} count={count} color={color}>
        {tasks.map((task) => (
          <DraggableCard key={task.id} task={task} onDrop={onDrop} onCardClick={onCardClick} />
        ))}
      </Column>
    </div>
  );
};

export default DroppableColumn;
